export enum RecordEventEnum {
  "REQUEST_STATUS" = "REQUEST_STATUS",
  "RECORDING" = "RECORDING",
  "IDLE" = "IDLE",
}

export enum BroadcastEventEnum {
  "RECORDING" = "RECORDING",
}
